// Lokalny override – widget wyłączony (nie używamy Poczta Polska / InPost / DPD w tej instancji)
// @ts-nocheck

import React, { FC } from 'react';

interface IReceiverPoint {
  type?: string;
  symbol?: string;
  address?: Record<string, string>;
}

interface IProps {
  handleParcelLocker: (data: IReceiverPoint) => void;
  code?: string;
}

const GeoWidget: FC<IProps> = () => {
  return null;
};

export default GeoWidget;
